/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_CalendarInputs */

const en_portalframe_calendar = /** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const ar_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const he_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const ur_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const es_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const fr_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const de_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const pt_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const hi_portalframe_calendar = en_portalframe_calendar;

/** @type {(inputs: Portalframe_CalendarInputs) => LocalizedString} */
const bn_portalframe_calendar = en_portalframe_calendar;

/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Portalframe_CalendarInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_calendar = /** @type {((inputs?: Portalframe_CalendarInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_CalendarInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_calendar(inputs)
	if (locale === "he") return he_portalframe_calendar(inputs)
	if (locale === "ur") return ur_portalframe_calendar(inputs)
	if (locale === "es") return es_portalframe_calendar(inputs)
	if (locale === "fr") return fr_portalframe_calendar(inputs)
	if (locale === "de") return de_portalframe_calendar(inputs)
	if (locale === "pt") return pt_portalframe_calendar(inputs)
	if (locale === "hi") return hi_portalframe_calendar(inputs)
	if (locale === "bn") return bn_portalframe_calendar(inputs)
	return /** @type {LocalizedString} */ ("Calendar")
});